import { FoodBookingModel } from '@xeetr/types/models'

export const RoomColumn = (booking: FoodBookingModel) => booking.room?.name ?? ''
